import { render, staticRenderFns } from "./TransferSettlement.vue?vue&type=template&id=31980793&scoped=true"
import script from "./TransferSettlement.vue?vue&type=script&lang=js"
export * from "./TransferSettlement.vue?vue&type=script&lang=js"
import style0 from "./TransferSettlement.vue?vue&type=style&index=0&id=31980793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31980793",
  null
  
)

export default component.exports